<div class="transport-tile-list">
  <div class="tile-container">

    @if (layoutDefinition != null) {
      @for (t of transportsForView; track t) {
        <div class="tile" (click)="toggleSelection(t)" class="tile"
          [ngClass]="{'selected': selectedTransportId === t.id}">
          <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
            [transport]="t.transportDetails">
          </app-transport-details>
        </div>
        <sc-list-spacer></sc-list-spacer>
      }
    }


  </div>
  <div class="count-bar">
    <div class="count-bar-layout">
      <div class="count">
        <span class="label">
          <sc-dictionary-label dictionaryKey="tmc.visit.overview.total-count"></sc-dictionary-label>
        </span>
        <span class="value">{{totalCount}}</span>
      </div>

      <div class="count">
        <span class="label">
          <sc-dictionary-label dictionaryKey="tmc.visit.overview.planned-count"></sc-dictionary-label>
        </span>
        <span class="value">{{plannedCount}}</span>
      </div>

      <div class="count">
        <span class="label">
          <sc-dictionary-label dictionaryKey="tmc.visit.overview.in-progress-count"></sc-dictionary-label>
        </span>
        <span class="value">{{inProgressCount}}</span>
      </div>

      <div class="count">
        <span class="label">
          <sc-dictionary-label dictionaryKey="tmc.visit.overview.finished-count"></sc-dictionary-label>
        </span>
        <span class="value">{{finishedCount}}</span>
      </div>
    </div>
  </div>
</div>
